import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent.vue?vue&type=template&id=55a12688&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent.vue?vue&type=style&index=0&id=55a12688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a12688",
  null
  
)

export default component.exports